import { Component, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { SaveChangesService } from '@app/services/save-changes/save-changes.service';

export const saveChangesGuard: CanDeactivateFn<unknown> = (
  _component: Component,
  _route: ActivatedRouteSnapshot,
  _currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot
) => {
  const saveChanges = inject(SaveChangesService);
  saveChanges.notify(saveChanges.hasChanges ? nextState.url : undefined);
  return !saveChanges.hasChanges;
};
